import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'

// const JSESSIONID = 'jsessionid'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function setJsessionId(token) {
  return Cookies.set('JSESSIONID', token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js